<script lang="ts">
import { Option } from 'element-ui';
export default Option;
</script>
